/**
 * Created by Reda on 21.07.2026
 */

cleverapps.SkinManager.SKINS.adventure4_expedition = cleverapps.override(cleverapps.clone(cleverapps.SkinManager.SKINS.adventure_expedition_base, true), {
    bundle: "expedition_adventure4",

    slots: {
        gameAudio: function () {
            return bundles.expedition_adventure4.urls.adventure_music;
        },

        showOneIngredientLeft: function () {
            return true;
        },

        customerStayFocused: function () {
            return true;
        },

        customerInfoViewFont: function () {

        },

        startQuestsEffect: function () {
            return "quests.start.adventure4";
        },

        lockedFogSoundEffect: function () {
            return bundles.extra_sound_effects_adventure4.urls.zoom_fog_effect;
        },

        worker_json: bundles.merge_adventure4 && bundles.merge_adventure4.jsons.worker_json
    }
});